export default function ErrorsRouteConfig($stateProvider) {
  'ngInject';

  $stateProvider
    .state('unauthorized', {
      url: '/unauthorized',
      template: require('./unauthorized/unauthorized.html'),
      data: {
        flex: true
      }
    })
    .state('error', {
      url: '/error',
      template: '<error></error>'
    });
}
